import { RootState } from 'redux/store';
import { createSelector } from '@reduxjs/toolkit';
import { mainMenuEditToMainMenu } from 'utils/converter/main-menu-item';
import { MainMenuItemModel } from 'types/entity';

const selectSelf = (state: RootState) => state;
const getMainMenuState = createSelector(selectSelf, (state) => state.mainMenuUpdate);

const getLoaded = createSelector(getMainMenuState, (state) => state.loaded);

const getTouched = createSelector(getMainMenuState, (state) => state.touched);

const getApplied = createSelector(getMainMenuState, (state) => state.applied);

const getEditingItems = createSelector(getMainMenuState, (state) => {
  const items = [...state.editingItems];
  return items.sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
});

const getEditingMainMenuId = createSelector(getMainMenuState, (state) => state.editingMainMenuId);

const getFixedEntities = createSelector(getMainMenuState, (state) => state.fixedEntities);

const getFixedEntitiesByLocale = createSelector(
  selectSelf,
  (state: RootState) => {
    const { locale } = state.userRead.entity;
    const map = state.mainMenuUpdate.fixedEntities;
    const mapByLocale: { [main_menu_id: string]: MainMenuItemModel[] } = Object.entries(map)
      .map(([mainMenuId, items]) => {
        // 変換
        const itemsByLocale = items.map((item) => mainMenuEditToMainMenu(item, locale));
        return { [mainMenuId]: itemsByLocale.sort((a, b) => (a.display_order || 0) - (b.display_order || 0)) };
      })
      // アイテムの数が多くて重くなるようだったら↑の処理と1つにまとめる
      .reduce((pre, entity) => ({ ...pre, ...entity }), {});
    return mapByLocale;
  },
);

export const mainMenuUpdateQuery = {
  getLoaded,
  getTouched,
  getApplied,
  getEditingItems,
  getEditingMainMenuId,
  getFixedEntities,
  getFixedEntitiesByLocale,
};
